import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { BreakpointMobile } from '../../../../constants/ui';

const NDVIToggleButton = ({ t, isActive, widthViewport, onClickButton }) => {
  return (
    <Button
      className={`${styles.ndviButton} ${isActive ? styles.ndviButtonActive : ''}`}
      size={'large'}
      onClick={onClickButton}
    >
      <div className={styles.ndviButtonSwitch}></div>
      {widthViewport > BreakpointMobile ? (
        <>{isActive ? t('map.hideNdvi') : t('map.showNdvi')}</>
      ) : (
        <>{isActive ? 'NDVI' : 'NDVI'}</>
      )}
    </Button>
  );
};

export default NDVIToggleButton;
